export default function ZHBMembership() {
    return (
<div>
        <h4>Members</h4>
              <hr/>
               <p>
                <b>Michele McGowan</b>
                <br/>
                Term Expires: January 2027
              </p>
              <p>
                <b>Hussam Jallad</b>
                <br/>
                Term Expires: January 2028
              </p>
              <p>
                <b>Suzanne Zukowski</b>&nbsp;<i>Secretary</i>
                <br/>
                Term Expires: January 2029
              </p>
               <p>
                <b>Amy Yates Wuefling</b>&nbsp;<i>Alternate</i>
                <br/>
                Term Expires: January 2027
              </p>
              <br/>
</div>
    )
}